module.exports = __webpack_public_path__ + "img/royal-mail.1807bd16.png";